import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { useParams, Link } from "react-router-dom";
import { Product } from "types";
import { Variant } from "types";
import { useDispatch } from "react-redux";
import { useAppSelector, useAppDispatch } from "../../redux/hooks";
import { addToCart } from "../../redux/slices/cartSlice";
import { CartItem } from "types";
import { toast, ToastContainer } from "react-toastify";
import { TaxGroup, TaxRule } from "types";
// import "react-toastify/dist/ReactToastify.css";
import { getAuthCookie } from "../../utils/authCookies";

// type Dimensions = {
//   length: number;
//   height: number;
//   width: number;
//   weight: number;
// };

// type Variant = {

//   variant_name: string;
//   sku: string;
//   attributes: string;
//   purchase_price: number;
//   retail_price: number;
//   package_dimensions: {
//     length: number;
//     height: number;
//     width: number;
//     weight: number;
//     weight_type: string;
//   };
//   inventory: [
//     {
//       warehouse_id: string;
//       warehouse_name: string;
//       on_hand: number;
//       available: number;
//       reserved: number;
//     }
//   ];
// };

// type Product = {
//   product_id: string;
//   name: string;
//   product_type: string;
//   sku: string;
//   description: string;
//   brand: string;
//   category: string;
//   item_condition: string;
//   purchase_price: number;
//   retail_price: number;
//   package_dimensions: Dimensions;
//   threshold_qty: number;
//   variants: Variant[];
//   condition_note: string;
//   image: Image | null;
//   status: string;
//   is_rotational: boolean;
//   tax_rule: string;
//   is_taxable: boolean;
// };

// type Image = {
//   url: string;
// };

type ProductObj = {
  product_id: string;
  signage_company_id: string;
  product: Product;
  created_by: {
    id: string;
    name: string;
  };
};

// type TaxGroup = {
//   id: string;
//   name: string;
//   status: string;
// };

// type TaxRule = {
//   id: string;
//   country: string;
//   state: string;
//   stateCode: string;
//   county: string;
//   countyCode: string;
//   zipCodes: string[];
//   taxRate: number;
//   comments: string;
//   status: string;
// };

type StorageLocation = {
  bin_id: string;
  bin_name: string;
  rack_id: string;
  rack_name: string;
  warehouse_id: string;
  warehouse_name: string;
  zone_id: string;
  zone_name: string;
  on_hand: number;
  available: number;
  reserved: number;
};

const AgentViewProductVariant = () => {
  const { productId } = useParams<{ productId: string }>();
  const { variantId } = useParams<{ variantId: string }>();
  const { signageId } = useParams<{ signageId: string }>();
  const [loading, setLoading] = useState(true);
  const token = getAuthCookie("sessionToken");
  const userId = getAuthCookie("userId");
  const [product, setProduct] = useState<Product>();
  const [productobj, setProductObj] = useState<ProductObj>();
  const [productImages, setProductImages] = useState<string[]>([]);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [variants, setVariants] = useState<Variant[]>([]);
  const [quantity, setQuantity] = useState(1);
  const cart = useAppSelector((state) => state.cart.items);
  console.log("Cart Items:", cart);
  const dispatch = useAppDispatch();

  const handleIncrease = () => setQuantity((prev) => prev + 1); // Increase quantity
  const handleDecrease = () => setQuantity((prev) => (prev > 1 ? prev - 1 : 1)); // Decrease quantity


  const handleAddToCart = async (product: CartItem) => {
    console.log("Add to cart product:", product);
    dispatch(addToCart(product));

    let currentCartId = localStorage.getItem("cart_id") || "";

    try {
      let response;
      if (!currentCartId) {
        // 🔹 Create new cart
        response = await fetch(`${process.env.REACT_APP_API_URL}/carts`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            cart_items: [product],
          }),
        });

        if (!response.ok) throw new Error("Failed to add data");
        const result = await response.json();
        if (result.cart_id) {
          localStorage.setItem("cart_id", result.cart_id);
        }
      } else {
        // 🔹 Add to existing cart
        response = await fetch(
          `${process.env.REACT_APP_API_URL}/carts/${currentCartId}/add-product`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(product),
          }
        );

        if (!response.ok) throw new Error("Failed to add data");
        const result = await response.json();
      }

      toast.success("Product added to cart successfully!");
    } catch (err) {
      console.error(err instanceof Error ? err.message : "Unknown error");
    }
  };


  // Fetch product data
  useEffect(() => {
    const fetchProduct = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/signage/${signageId}/inventory/${productId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (!response.ok) {
          throw new Error("Failed to fetch product data");
        }

        const data: ProductObj = await response.json();
        console.log("Fetched Product Data:", data);
        // setProduct(data);
        setProductObj(data);
        setProductImages(data.product.image ? [data.product.image.url] : []);
        setVariants(data?.product?.variants);
      } catch (err) {
        console.error("Error fetching product data:", err);
      } finally {
        setLoading(false);
      }
    };

    if (productId) fetchProduct();
  }, [productId, token]);

  console.log('Variants:', variants);

  const findVariantDetails = (variants: Variant[], variantId: string | undefined): Variant | undefined => {
    if (!variantId || !variants) return undefined;

    return variants?.find((variant) => variant?.variant_id === variantId);
  };

  const [selectedVariant, setSelectedVariant] = useState<Variant | null>(null);

  useEffect(() => {
    const variant = findVariantDetails(variants, variantId);
    setSelectedVariant(variant || null);
    console.log('Variant details:', variant);
  }, [variants, variantId]);

  return (
    <div className="page-content p-0">
      <div className="card">
        <div className="card-body">
          <h2 className="ps-4">Product Details </h2>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <ul className="nav nav-pills nav-success mb-3" role="tablist">
                {/* <li className="nav-item waves-effect waves-light">
                  <a
                    className="nav-link active"
                    data-bs-toggle="tab"
                    href="#product-details"
                    role="tab"
                  >
                    Product Details
                  </a>
                </li> */}
                {/* <li className="nav-item waves-effect waves-light">
                  <a
                    className="nav-link"
                    data-bs-toggle="tab"
                    href="#images"
                    role="tab"
                  >
                    Images
                  </a>
                </li>
                <li className="nav-item waves-effect waves-light">
                  <a
                    className="nav-link"
                    data-bs-toggle="tab"
                    href="#orders"
                    role="tab"
                  >
                    Orders
                  </a>
                </li>
                <li className="nav-item waves-effect waves-light">
                  <a
                    className="nav-link"
                    data-bs-toggle="tab"
                    href="#inventory-log"
                    role="tab"
                  >
                    Inventory Log
                  </a>
                </li> */}
              </ul>
              <div className="tab-content text-muted">
                <div
                  className="tab-pane active"
                  id="product-details"
                  role="tabpanel"
                >
                  <div className="row gx-lg-5">
                    <div className="col-xl-4 col-md-8 mx-auto">

                      <div className="product-slider-container">
                        <img src={`${process.env.REACT_APP_BASE_URL}${productobj?.product?.image?.url}`} className="img-fluid" />
                        {/* <Swiper
                      modules={[Navigation, Thumbs]}
                      navigation
                      thumbs={{ swiper: thumbsSwiper }}
                      spaceBetween={10}
                      slidesPerView={1}
                    >
                      {productImages?.map((img, index) => (
                        <SwiperSlide key={index}>
                          <img
                            src={`${process.env.REACT_APP_BASE_URL}${img}`}
                            alt={`Slide ${index + 1}`}
                          />
                        </SwiperSlide>
                      ))}
                    </Swiper> */}

                        {/* Thumbnail Slider */}
                        {/* <Swiper
                      modules={[Thumbs]}
                      // onSwiper={setThumbsSwiper}
                      spaceBetween={10}
                      slidesPerView={4}
                      watchSlidesProgress
                    >
                      {productImages?.map((img, index) => (
                        <SwiperSlide key={index}>
                          <img
                            src={`${process.env.REACT_APP_BASE_URL}${img}`}
                            alt={`Thumbnail ${index + 1}`}
                          />
                        </SwiperSlide>
                      ))}
                    </Swiper> */}
                      </div>
                    </div>

                    <div className="col-xl-8">
                      <div className="mt-xl-0 mt-5">
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            {/* <h2>{productobj?.product?.name}</h2> */}
                            <h3>{selectedVariant?.variant_name || ""}</h3>

                          </div>
                          <div className="flex-shrink-0">
                            <div>


                            </div>
                          </div>
                        </div>



                        <div className="row mt-4">
                          <div className="col-lg-3 col-sm-6">
                            <div className="p-2 border border-dashed rounded">
                              <div className="d-flex align-items-center">
                                <div className="avatar-sm me-2">
                                  <div className="avatar-title rounded bg-transparent text-success fs-24">
                                    <i className="ri-money-dollar-circle-fill"></i>
                                  </div>
                                </div>
                                <div className="flex-grow-1">
                                  <p className="text-muted mb-1">Price :</p>
                                  <h5 className="mb-0">
                                    ${selectedVariant?.retail_price || ""}
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-3 col-sm-6">
                            <div className="p-2 border border-dashed rounded">
                              <div className="d-flex align-items-center">
                                <div className="avatar-sm me-2">
                                  <div className="avatar-title rounded bg-transparent text-success fs-24">
                                    <i className="ri-file-copy-2-fill"></i>
                                  </div>
                                </div>
                                <div className="flex-grow-1">
                                  <p className="text-muted mb-1">SKU :</p>
                                  <h5 className="mb-0">
                                    {selectedVariant?.sku || ""}
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          {Object.entries(
                            productobj?.product?.variants[0]?.attributes || {}
                          ).map(([key, value], index) => (
                            <div className="col-xl-6" key={index}>
                              <div className="mt-4">
                                <h5 className="fs-14">{key} :</h5>
                                <div className="d-flex flex-wrap gap-2">
                                  <div
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="top"
                                    title="Out of Stock"
                                  >
                                    <input
                                      type="radio"
                                      className="btn-check"
                                      name="productsize-radio"
                                      id="productsize-radio1"
                                      disabled
                                    />

                                    {value}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}

                        </div>

                        <div className="row mt-3">
                          <div className="col-md-6">
                            {/* Quantity Controls */}
                            <div className="row mb-5">
                              <div className="col-md-3">
                                <label htmlFor="">Quantity: </label>
                              </div>
                              <div className="col-md-6">
                                <div className="input-group">
                                  <button
                                    className="btn btn-outline-secondary"
                                    type="button"
                                    onClick={handleDecrease}
                                  >
                                    -
                                  </button>
                                  <input
                                    type="text"
                                    className="form-control text-center"
                                    value={quantity}
                                    readOnly
                                  />
                                  <button
                                    className="btn btn-outline-secondary"
                                    type="button"
                                    onClick={handleIncrease}
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                            </div>

                            <button
                              onClick={() => {
                                if (productobj?.product) {
                                  const inventoryItem = productobj?.product?.variants[0]?.inventory?.[0] as StorageLocation;
                                  handleAddToCart({
                                    product_id: productobj?.product_id || "",
                                    variant_id: variantId || "",
                                    warehouse_id: selectedVariant?.inventory[0]?.warehouse_id || "",
                                    name: selectedVariant?.variant_name || "",
                                    sku: selectedVariant?.sku || "",
                                    unit_purchase_price: Number(selectedVariant?.purchase_price || 0),
                                    unit_retail_price: Number(selectedVariant?.retail_price || 0),
                                    quantity: quantity,
                                    tax_details: {
                                      tax_rate: productobj?.product?.tax_rule ? productobj?.product?.tax_rule.taxRate : 0,
                                      tax_amount: 0,
                                      applied_state: productobj?.product?.tax_rule ? productobj?.product?.tax_rule.state : "",
                                    },
                                    tax_rule: productobj?.product?.tax_rule || null,
                                    tax_group: productobj?.product?.tax_group || null,
                                    image_url: productobj?.product?.image?.url ?? "",
                                    amount: 0,
                                    storage_location:
                                      {
                                        // available: inventoryItem?.available || 0,
                                        // reserved: inventoryItem?.reserved || 0,
                                        // on_hand: inventoryItem?.on_hand || 0,
                                        bin_id: inventoryItem?.bin_id || "",
                                        bin: inventoryItem?.bin_name || "",
                                        rack_id: inventoryItem?.rack_id || "",
                                        rack: inventoryItem?.rack_name || "",
                                        warehouse_id: inventoryItem?.warehouse_id || "",
                                        warehouse: inventoryItem?.warehouse_name || "",
                                        zone_id: inventoryItem?.zone_id || "",
                                        zone: inventoryItem?.zone_name || "",
                                      },
                                  });
                                }
                              }}
                              className="btn btn-success"
                            >
                              Add to Cart
                            </button>
                          </div>
                        </div>

                        <div className="mt-4 text-muted">
                          <h5 className="fs-14">Description :</h5>
                          <p>{productobj?.product?.description}</p>
                        </div>

                        <div className="product-content mt-5">
                          <nav>
                            <ul
                              className="nav nav-tabs nav-tabs-custom nav-success"
                              id="nav-tab"
                              role="tablist"
                            >
                              <li className="nav-item">
                                <a
                                  className="nav-link active"
                                  id="nav-speci-tab"
                                  data-bs-toggle="tab"
                                  href="#nav-speci"
                                  role="tab"
                                  aria-controls="nav-speci"
                                  aria-selected="true"
                                >
                                  Specification
                                </a>
                              </li>
                              <li className="nav-item">
                                <a
                                  className="nav-link"
                                  id="nav-detail-tab"
                                  data-bs-toggle="tab"
                                  href="#nav-detail"
                                  role="tab"
                                  aria-controls="nav-detail"
                                  aria-selected="false"
                                >
                                  Details
                                </a>
                              </li>
                            </ul>
                          </nav>
                          <div
                            className="tab-content border border-top-0 p-4"
                            id="nav-tabContent"
                          >
                            <div
                              className="tab-pane fade show active"
                              id="nav-speci"
                              role="tabpanel"
                              aria-labelledby="nav-speci-tab"
                            >
                              <div className="table-responsive">
                                <table className="table mb-0">
                                  <tbody>
                                    <tr>
                                      <th scope="row" style={{ width: "200px" }}>
                                        Category
                                      </th>
                                      <td>{productobj?.product?.category}</td>
                                    </tr>
                                    <tr>
                                      <th scope="row">Brand</th>
                                      <td>{productobj?.product?.brand}</td>
                                    </tr>
                                    <tr>
                                      <th scope="row">Dimensions</th>
                                      <td>
                                        {
                                          productobj?.product?.package_dimensions
                                            ?.length
                                        }{" "}
                                        x{" "}
                                        {
                                          productobj?.product?.package_dimensions
                                            ?.width
                                        }{" "}
                                        x{" "}
                                        {
                                          productobj?.product?.package_dimensions
                                            ?.height
                                        }
                                      </td>
                                    </tr>
                                    <tr>
                                      <th scope="row">Weight</th>
                                      <td>
                                        {
                                          productobj?.product?.package_dimensions
                                            ?.weight
                                        }{" "}
                                        Gram
                                      </td>
                                    </tr>
                                    <tr>
                                      <th scope="row">Item Condition</th>
                                      <td>{productobj?.product?.item_condition}</td>
                                    </tr>
                                    <tr>
                                      <th scope="row">Is Rotational </th>
                                      <td>{(productobj?.product?.is_rotational) ? 'Yes' : 'No'}</td>
                                    </tr>

                                  </tbody>
                                </table>
                              </div>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="nav-detail"
                              role="tabpanel"
                              aria-labelledby="nav-detail-tab"
                            >
                              <div>
                                <h5 className="font-size-16 mb-3">
                                  {productobj?.product?.name}
                                </h5>
                                <p>{productobj?.product?.description}</p>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="tab-pane" id="images" role="tabpanel">
                  <div className="d-flex mt-2">
                    <div className="card">
                      <div className="card-header">
                        <h5 className="card-title mb-0">Product Gallery</h5>
                      </div>
                      <div className="card-body">
                       
                        <div>
                          <h5 className="fs-14 mb-1">Product Gallery</h5>
                          <p className="text-muted">
                            Add Product Gallery Images.
                          </p>                         

                          <ul
                            className="list-unstyled mb-0"
                            id="dropzone-preview"
                          >
                            <li className="mt-2" id="dropzone-preview-list">
                              <div className="border rounded">
                                <div className="d-flex p-2">
                                  <div className="flex-shrink-0 me-3">
                                    <div className="avatar-sm bg-light rounded">
                                      <img
                                        data-dz-thumbnail
                                        className="img-fluid rounded d-block"
                                        src="#"
                                        alt="Product-Image"
                                      />
                                    </div>
                                  </div>
                                  <div className="flex-grow-1">
                                    <div className="pt-1">
                                      <h5 className="fs-14 mb-1" data-dz-name>
                                        &nbsp;
                                      </h5>
                                      <p
                                        className="fs-13 text-muted mb-0"
                                        data-dz-size
                                      ></p>
                                      <strong
                                        className="error text-danger"
                                        data-dz-errormessage
                                      ></strong>
                                    </div>
                                  </div>
                                  <div className="flex-shrink-0 ms-3">
                                    <button
                                      data-dz-remove
                                      className="btn btn-sm btn-danger"
                                    >
                                      Delete
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tab-pane" id="orders" role="tabpanel">
                  <div className="d-flex mt-2">
                    <p>Orders</p>
                  </div>
                </div>
                <div className="tab-pane" id="inventory-log" role="tabpanel">
                  <div className="d-flex mt-2">
                    <p>Iventory logs</p>
                  </div>
                </div> */}
              </div>

            </div>
          </div>
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-md-12 col-lg-12 col-xl-12">
          <div className="mt-0 card-bg-fill">
            <div className="pt-1">
              <div className="pt-1 mt-1"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentViewProductVariant;
